import { render, staticRenderFns } from "./goods-physical.vue?vue&type=template&id=fb991c2e&scoped=true"
import script from "./goods-physical.vue?vue&type=script&lang=js"
export * from "./goods-physical.vue?vue&type=script&lang=js"
import style0 from "./goods-physical.vue?vue&type=style&index=0&id=fb991c2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb991c2e",
  null
  
)

export default component.exports